import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../src/loginPage.css";
import { forgotPasswordApi } from "../api/changeAndResetPasswordApi";
import { getApiErrorMessage } from "../utils/apiError";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState(location?.state?.email || "");
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await forgotPasswordApi({ email });

      if (response?.status === false) {
        // use backend message if provided
        setError(response.message || "Invalid email");
        return;
      }

      if (response?.status === true) {
        setIsSuccess(true);
      }
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to send reset email. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  /* SUCCESS STATE */
  if (isSuccess) {
    return (
      <>
        <button
          type="button"
          className="link-button"
          style={{ marginBottom: "12px" }}
          onClick={() => navigate("/")}
        >
          ← Back
        </button>

        <div className="login-container">
          <h2>Forgot Password</h2>
          <p style={{ color: "green", textAlign: "center" }}>
            Reset email sent successfully.
          </p>
        </div>
      </>
    );
  }

  /* DEFAULT STATE */
  return (
    <>    
      <div className="login-container">
        <button
          type="button"
          className="back-button"
          style={{ marginBottom: "12px" , color:'black'}}
          onClick={() => navigate("/")}
        >
          ← Back
        </button>
        <h2>Forgot Password</h2>
      <div className="input-group">
        <label>Email</label>
        <input
          type="email"
          placeholder="Enter registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            borderColor: error ? "red" : undefined,
          }}
        />
      </div>

      {error && <p className="error-message">{error}</p>}

      <button
        className="login-button"
        onClick={handleSendOtp}
        disabled={!email || loading}
      >
        {loading ? "Sending..." : "Send Link"}
      </button>
    </div>
    </>
  );
};

export default ForgotPassword;
